import { Button, PaletteCircle } from '@sparemin/blockhead';
import * as React from 'react';

import Tooltip from 'components/Tooltip';
import { FeatureLockState, UNLOCKED } from 'redux/modules/embed/selectors';
import CaptionsFormControl from './CaptionsFormControl';
import { block } from './utils';

interface IProps {
  isDisabled: boolean;
  lockState?: FeatureLockState;
  onPress?: () => void;
}

const CaptionsStyleButton: React.SFC<IProps> = ({
  isDisabled,
  lockState = UNLOCKED,
  onPress,
}) => (
  <Tooltip
    animation={false}
    content={lockState.tooltip ?? 'Text styles & animation'}
    id="text-styles-tooltip"
    placement="top"
    preventHideOnHover={false}
  >
    <CaptionsFormControl>
      <Button
        className={block('style-button')}
        onPress={onPress}
        isDisabled={isDisabled || lockState.disabled}
        size="small"
        startIcon={<PaletteCircle />}
      >
        Style captions
      </Button>
    </CaptionsFormControl>
  </Tooltip>
);

export default CaptionsStyleButton;
export { IProps as CaptionsStyleButtonProps };
